var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilePortrait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5649 1.75H8.43488C7.2042 1.75 6.20654 2.74766 6.20654 3.97833V24.0217C6.20654 25.2523 7.2042 26.25 8.43488 26.25H19.5649C20.7956 26.25 21.7932 25.2523 21.7932 24.0217V3.97833C21.7932 2.74766 20.7956 1.75 19.5649 1.75Z",
    stroke: "#998147",
    strokeWidth: 1.78,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2284 2.85833H11.7717C11.6206 2.86025 11.4708 2.83093 11.3316 2.7722C11.1924 2.71348 11.0668 2.62662 10.9627 2.51708C10.8587 2.40754 10.7783 2.27768 10.7268 2.13564C10.6753 1.9936 10.6537 1.84245 10.6634 1.69167H17.3367C17.3464 1.84245 17.3248 1.9936 17.2732 2.13564C17.2217 2.27768 17.1414 2.40754 17.0374 2.51708C16.9333 2.62662 16.8077 2.71348 16.6685 2.7722C16.5293 2.83093 16.3795 2.86025 16.2284 2.85833Z",
    stroke: "#998147",
    strokeWidth: 1.78,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8916 22.9133H15.1083",
    stroke: "#998147",
    strokeWidth: 1.78,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilePortrait);
export default __webpack_public_path__ + "static/media/mobile-portrait.7d6c59d954a48b445243f067e4ed965f.svg";
export { ForwardRef as ReactComponent };